import {
    searchState as searchStateUtil,
    quickFilters as quickFiltersUtil,
} from 'utils';

function getQuickFiltersLength(category = {}, refinedItems) {
    const context = category.context || {};
    return (
        context.quickFilters &&
        context.quickFilters.filter(
            quickFilter =>
                quickFiltersUtil.isQuickLink(quickFilter) ||
                quickFiltersUtil.shouldShowQuickFilters(
                    quickFilter,
                    refinedItems,
                ),
        ).length
    );
}

function hasPromotedFilters(category = {}, featureFlags = {}) {
    const context = category.context || {};
    return !!(
        context.promotedFilters &&
        context.promotedFilters.length > 0 &&
        featureFlags.hasPromotedFiltersEnabled &&
        featureFlags.hasGuidedNavigationEnabled
    );
}

function hasTipsheetCard(category = {}) {
    const context = category.context || {};
    return !!(context.tipsheet && context.tipsheet.link);
}

function getNumberOfExtraCards(
    category = {},
    refinedItems = [],
    featureFlags = {},
    nbResultPerPage,
) {
    let extraCards = 0;

    const quickFiltersLength = getQuickFiltersLength(category, refinedItems);
    if (
        quickFiltersLength > 0 &&
        featureFlags.hasGuidedNavigationEnabled &&
        featureFlags.hasQuickFiltersCardEnabled
    ) {
        extraCards += quickFiltersLength;
    }

    if (hasTipsheetCard(category)) {
        extraCards++;
    }

    return getMaxInGridElements(
        nbResultPerPage,
        featureFlags.maxPercentageOfInGridElements,
        extraCards,
    );
}

function getMaxInGridElements(
    nbResultPerPage,
    maxPercentageOfInGridElements = 100,
    extraCards,
) {
    const maxElements = Math.floor(
        (maxPercentageOfInGridElements / 100) * nbResultPerPage,
    );
    return Math.min(maxElements, extraCards);
}

export function buildPaginationOffsetInfo(
    nbResultPerPage,
    category = {},
    refinedItems = [],
    searchState = {},
    landingProductModelId,
    featureFlags = {},
) {
    // If we are not in a category page we can skip everything
    if (!category.context) {
        return {
            listingOffset: 0,
            firstPageLength: nbResultPerPage,
            nbResultPerPage,
        };
    }

    const hasActiveFilters = !searchStateUtil.hasNoActiveFilter(searchState);
    const promotedFilters =
        hasPromotedFilters(category, featureFlags) && !landingProductModelId
            ? 1
            : 0;
    const filtersApplied = hasActiveFilters ? 1 : 0;
    const extraCards = getNumberOfExtraCards(
        category,
        refinedItems,
        featureFlags,
        nbResultPerPage,
    );

    const firstPageLength =
        nbResultPerPage -
        extraCards +
        (1 - filtersApplied) * (1 - promotedFilters);

    const listingOffset = nbResultPerPage - firstPageLength;

    return {
        listingOffset,
        firstPageLength,
        nbResultPerPage,
    };
}

export function getCurrentPagination(
    paginationOffset,
    currentPage,
    nbResultPerPage,
) {
    let currentPageOffset = 0;
    let resultsLength = paginationOffset.firstPageLength;

    if (currentPage > 1) {
        currentPageOffset =
            (currentPage - 1) * nbResultPerPage -
            paginationOffset.listingOffset;
        resultsLength = nbResultPerPage;
    }

    return { offset: currentPageOffset, length: resultsLength };
}

export default {
    buildPaginationOffsetInfo,
    getCurrentPagination,
};
